import React, { useState, useEffect } from 'react';
import { db, auth } from '../firebase';
import { doc, onSnapshot, setDoc, getDoc } from 'firebase/firestore';
import { questions } from '../questions';
import './QuestionOfTheDay.css';

const QuestionOfTheDay = () => {
    const [user, setUser] = useState(null);
    const [coupleId, setCoupleId] = useState(null);
    const [coupleData, setCoupleData] = useState(null);
    const [answer, setAnswer] = useState('');
    const [loading, setLoading] = useState(true);

    // Get the question for the current day
    const getDailyQuestion = () => {
        const dayOfYear = Math.floor((Date.now() - new Date(new Date().getFullYear(), 0, 0)) / 86400000);
        const questionIndex = dayOfYear % questions.length;
        return questions[questionIndex];
    };
    const dailyQuestion = getDailyQuestion();

    useEffect(() => {
        const unsubAuth = auth.onAuthStateChanged(async (currentUser) => {
            if (currentUser) {
                const userDocRef = doc(db, 'users', currentUser.uid);
                const userDocSnap = await getDoc(userDocRef);
                if (userDocSnap.exists()) {
                    const userData = userDocSnap.data();
                    setUser(userData);
                    if (userData.partnerId) {
                        const ids = [currentUser.uid, userData.partnerId].sort();
                        setCoupleId(ids.join('_'));
                    } else {
                        setLoading(false);
                    }
                }
            } else {
                setUser(null);
                setCoupleId(null);
                setLoading(false);
            }
        });
        return () => unsubAuth();
    }, []);

    useEffect(() => {
        if (!coupleId) return;
        const coupleDocRef = doc(db, 'coupleData', coupleId);
        const unsubscribe = onSnapshot(coupleDocRef, (docSnap) => {
            setCoupleData(docSnap.exists() ? docSnap.data() : {});
            setLoading(false);
        });
        return () => unsubscribe();
    }, [coupleId]);

    const handleAnswerSubmit = async (e) => {
        e.preventDefault();
        if (answer.trim() === '' || !coupleId) return;

        const today = new Date().toDateString();
        const uid = auth.currentUser.uid;
        const coupleDocRef = doc(db, 'coupleData', coupleId);

        await setDoc(coupleDocRef, {
            dailyAnswers: {
                [today]: {
                    [uid]: answer
                }
            }
        }, { merge: true });

        setAnswer('');
    };

    if (loading) {
        return <div className="qotd-container">Loading...</div>;
    }
    if (!user?.partnerId) {
        return null; // Don't show if not linked
    }

    const today = new Date().toDateString();
    const answersForToday = coupleData?.dailyAnswers?.[today] || {};
    const myAnswer = answersForToday[auth.currentUser.uid];
    const partnerAnswer = answersForToday[user.partnerId];

    return (
        <div className="qotd-container">
            <h2>Question of the Day</h2>
            <p className="qotd-question">{dailyQuestion}</p>

            {!myAnswer && (
                <form onSubmit={handleAnswerSubmit} className="qotd-form">
                    <input
                        type="text"
                        value={answer}
                        onChange={(e) => setAnswer(e.target.value)}
                        placeholder="Your answer..."
                        required
                    />
                    <button type="submit">Submit</button>
                </form>
            )}

            {myAnswer && (
                <div className="qotd-answers">
                    <div className="qotd-answer your-answer">
                        <strong>You said:</strong>
                        <p>{myAnswer}</p>
                    </div>
                    {partnerAnswer ? (
                        <div className="qotd-answer partner-answer">
                            <strong>{user.partnerNickname || 'Your partner'} said:</strong>
                            <p>{partnerAnswer}</p>
                        </div>
                    ) : (
                        <div className="qotd-answer partner-answer waiting">
                            <p>Waiting for your partner's answer...</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default QuestionOfTheDay;
